<div class="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-10">
  <div class="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
    <div class="mb-6">
      <div class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
        Office of Violence Prevention
      </div>
      <h1 class="mt-2 text-2xl font-semibold text-slate-900">Sign in</h1>
      <p class="mt-2 text-sm text-slate-500">
        Access the DeKalb County case management system.
      </p>
    </div>

    <form class="space-y-4" [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700">Email</label>
        <input
          type="email"
          formControlName="email"
          class="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500"
          placeholder="you@example.com"
        />
        @if (form.controls.email.touched && form.controls.email.invalid) {
          <p class="mt-1 text-xs text-rose-600">Enter a valid email address.</p>
        }
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700">Password</label>
        <input
          type="password"
          formControlName="password"
          class="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500"
          placeholder="Password"
        />
        @if (form.controls.password.touched && form.controls.password.invalid) {
          <p class="mt-1 text-xs text-rose-600">Password is required.</p>
        }
      </div>

      @if (errorMessage()) {
        <div class="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">
          {{ errorMessage() }}
        </div>
      }

      <button
        type="submit"
        [disabled]="loading()"
        class="w-full rounded-xl bg-slate-900 px-4 py-3 text-sm font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60"
      >
        @if (loading()) {
          Signing in...
        } @else {
          Sign in
        }
      </button>

      <a
        href="/forgot-password"
        class="block w-full text-center text-sm text-slate-500 transition hover:text-slate-700"
      >
        Forgot password?
      </a>
      
    </form>
  </div>
</div>